import {createTheme} from '@mui/material/styles';
import {blueGrey, deepOrange, indigo, red} from '@mui/material/colors';

// A custom theme for this app
const theme = createTheme({
  palette: {
    mode: 'dark',
    primary: deepOrange,
    secondary: blueGrey,
    error: {
      main: red.A400,
    },
  },
});

export default theme;
